<p class="section-description">All mock issue types rendered with their respective components.</p>
<!-- Several issue components dereference `application` in ngOnInit, so
only mount issues-view once an application is actually loaded. -->
@if (application) {
  <issues-view [issues]="issues" [sync-pair]="syncPair" [application]="application"></issues-view>
} @else {
  <div class="notice-info">
    <svg lucideInfo></svg>
    <p>
      No application is loaded for this account, so issue components can't render. Modals below are still available for
      visual testing.
    </p>
  </div>
}
